import React from 'react';
import { DropdownButton, Dropdown } from 'react-bootstrap';

const InvoiceMenuSelect = ({deliveryId, onPrintInvoiceClick}) => {
    //data attributes are accesible via camel case version of what you put down there
    //this article is pretty sweet https://developer.mozilla.org/en-US/docs/Learn/HTML/Howto/Use_data_attributes

    return (
        <DropdownButton title="&#8942;">
            <Dropdown.Item data-delivery-id={deliveryId} onClick={onPrintInvoiceClick}>
                Print Invoice
            </Dropdown.Item>
        </DropdownButton>
    )
}

export default InvoiceMenuSelect;